<template>
  <BgImageLayout title="System Settings" :page="__guide.systemSettings" icon-color="white">
    <q-card class="bigger no-border-radius q-mb-md" color="white" text-color="dark-grey">
      <q-card-section>
        <Grid gtc="1fr 1fr" gap="15px">
          <div v-for="item of categoryItems" :key="item.category">
            <h6>{{ item.category }}</h6>

            <Grid gtc="repeat(auto-fit, minmax(250px, auto))" gap="10px" content-items="start">
              <q-item
                v-for="(listItem, index) in item.categoryList"
                :key="`listItem_${index}`"
                :to="listItem.link || undefined"
                clickable
                class="link-wrapper"
                @click="listItem.action && listItem.action()"
              >
                <div class="lm-link">
                  <span class="link-icon">
                    <i :class="`${listItem.icon} on-left`" class="fa" />
                  </span>

                  <span class="link-name">{{ listItem.name }}</span>
                </div>
              </q-item>
            </Grid>
          </div>
        </Grid>
      </q-card-section>
    </q-card>
  </BgImageLayout>
</template>

<script>
import * as apiTo from '@/modular-api'
import { downloadFile } from '@lib/generic.utils'
// Libraries
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('entity-labels', ['departmentLabel', 'costCenterLabel']),

    categoryItems() {
      const user = this.$store.state.user
      const isSystemAdmin = user && user.is_system_user

      return [
        {
          category: 'General',
          categoryList: [
            {
              name: 'Member settings',
              icon: 'fa-cogs',
              link: '/member-settings'
            },
            {
              icon: 'fa-user',
              name: 'Users settings',
              link: '/users-settings'
            },
            {
              name: 'FTE',
              icon: 'fa-tags',
              link: '/fte'
            },
            {
              name: 'IP addresses',
              icon: 'fa-location',
              link: '/ip-addresses'
            }
          ]
        },
        {
          category: 'Workflow',
          categoryList: [
            {
              name: 'Workflow settings',
              icon: 'fa-cogs',
              link: '/workflow-settings'
            },
            {
              name: 'Subscription workflow management',
              icon: 'fa-cogs',
              link: '/subscription-workflow-management'
            }
          ]
        },
        {
          category: 'Imports',
          categoryList: [
            ...(this.$store.getters.hasPermission('perform-data-imports')
              ? [
                  {
                    name: 'Data imports',
                    icon: 'fa-file',
                    link: '/data-imports'
                  }
                ]
              : []),
            {
              name: 'Previous imports',
              icon: 'fa-file',
              link: '/previous-imports'
            }
          ]
        },
        {
          category: 'Financial',
          categoryList: [
            {
              name: 'Financial periods',
              icon: 'fa-coins',
              link: `/financial-periods?year=${new Date().getFullYear()}`
            }
          ]
        },
        {
          category: 'Product',
          categoryList: [
            {
              name: 'Product types',
              icon: 'fa-file-powerpoint',
              link: '/product-types'
            },

            {
              name: 'Subject Categories',
              icon: 'fa-file-powerpoint',
              link: '/subject-categories'
            }
          ]
        },

        {
          category: `${this.departmentLabel.plural}, stakeholders and ${this.costCenterLabel.plural.toLowerCase()}`,
          categoryList: [
            {
              name: this.departmentLabel.plural,
              icon: 'fa-address-book',
              link: '/departments'
            },
            {
              name: 'Stakeholders',
              icon: 'fa-address-book',
              link: '/stakeholders'
            },
            {
              name: this.costCenterLabel.plural,
              icon: 'fa-address-book',
              link: '/cost-centers'
            }
          ]
        },
        {
          category: 'License',
          categoryList: [
            {
              name: 'License term labels',
              icon: 'fa-file-text',
              link: '/license-term-labels'
            },
            {
              name: 'License qualifier labels',
              icon: 'fa-file-text',
              link: '/license-qualifier-labels'
            }
          ]
        },
        {
          category: 'Todos',
          categoryList: [
            {
              name: 'Todo Templates',
              icon: 'fa-copy',
              link: '/todo-templates'
            }
          ]
        },
        {
          category: 'Metadata',
          categoryList: [
            {
              name: 'Categories',
              icon: 'fa-tags',
              link: '/meta-data-categories'
            },
            {
              name: 'Fields',
              icon: 'fa-tags',
              link: '/meta-data-fields'
            }
          ]
        },
        {
          category: 'Others',
          categoryList: [
            {
              name: 'Forms',
              icon: 'fa-globe',
              link: '/forms'
            },
            {
              name: 'Recent actions',
              icon: 'fa-globe',
              link: '/recent-actions'
            },
            ...(isSystemAdmin
              ? [
                  {
                    name: 'Download users report',
                    icon: 'fa-download',
                    action: this.downloadUsersReport
                  }
                ]
              : [])
          ]
        }
      ]
    }
  },

  methods: {
    downloadUsersReport() {
      apiTo.EXPORT_USERS().then(response => downloadFile(response))
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/stylus/custom-variables'

.bigger {
  padding 0 20px
}

.link-wrapper {
  text-align center
  padding 0

  .link-icon {
    color $primary
    font-size 1.2rem
    display block
  }

  .lm-link {
    color $primary
    border: 1px solid $tertiary;
    padding: 10px;
    border-radius: 5px;
    min-width 250px
    transition box-shadow .2s ease-in-out
  }

  .link-name {
    font-size 1rem
    display block
  }

  &:hover {
    .lm-link {
      box-shadow 0 0 15px 0 #ccc
    }
  }
}
</style>
